import http from "../../http-common";

class CatalogTabsService {
    getCatalogTabs(path: string, pageNumber: number, isSalePage?: boolean) {
      return http.get(`/education/catalog/tabs/${path}?pageNumber=${pageNumber}&isSalePage=${isSalePage}`);
    }
}

export default new CatalogTabsService();
